import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TTRowManager from './TTRowManager';
import { createRow, uploadFileTTRows } from 'redux/translationTable/TranslationTableActions';

const mapStateToProps = ({ translationTable }) => ({
  translationTableId: translationTable.translationTable.id
});

const mapDispatchToProps = dispatch => ({
  ttActions: bindActionCreators({ createRow, uploadFileTTRows }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(TTRowManager);



// WEBPACK FOOTER //
// ./src/shared/components/translationTable/c/ttRowManager/TTRowManagerConnector.js